import { IViewCard } from '@/components';

export const TabArrestsNextPaths = {
  KaseArrestList: ['KaseArrestView', 'KaseArrestEdit'],
};

export enum KaseArrestsScreens {
  KaseArrestList = 'KaseArrestList',
  KaseArrestEdit = 'KaseArrestEdit',
  KaseArrestView = 'KaseArrestView',
}

export const KaseArrestsNextRoutes = ['narratives', 'property'];

export const KaseArrestTableColumns = [
  { key: 'masterName', label: 'Arrestee name' },
  { key: 'arrestDate', label: 'Arrest date' },
  { key: 'arrestType', label: 'Arrest type' },
  { key: 'arrestStatus', label: 'Arrest status' },
  { key: 'action', label: '' },
];

export const arrestDataGridColumns = [
  {
    field: 'number',
    headerName: 'Arrestee number',
    width: 150,
    visible: true,
  },
  {
    field: 'arrestId',
    headerName: 'Arrest ID',
    width: 180,
    visible: true,
  },
  {
    field: 'masterName',
    headerName: 'Arrestee name',
    width: 320,
    visible: true,
  },
  {
    field: 'arrestDate',
    headerName: 'Arrest date',
    width: 250,
    visible: true,
  },
  {
    field: 'arrestType',
    headerName: 'Arrest type',
    width: 300,
    visible: true,
  },
  {
    field: 'arrestStatus',
    headerName: 'Arrest status',
    width: 300,
    visible: true,
  },
  {
    field: 'dataWorksStatus',
    headerName: 'DataWorks Status',
    width: 200,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 150,
    visible: true,
  },
];

export const PenalCodeTableColumns = [
  { key: 'number', label: 'Arrest Offense ID' },
  { key: 'penalCode', label: 'Penal code' },
  { key: 'lawDescription', label: 'Law description' },
  { key: 'attemptIndicator', label: 'Attempt Indicator' },
  { key: 'action', label: '' },
];

export const ArrestFileTableColumns = [
  { key: 'name', label: 'File name' },
  { key: 'description', label: 'Description' },
  { key: 'createdAt', label: 'Date uploaded' },
  { key: 'uploadedBy', label: 'Uploaded by' },
  { key: 'mimeType', label: 'File type' },
  { key: 'action', label: '' },
];

export const crimeArrestsViewFields = <Array<IViewCard & { method?: string }>>[
  {
    title: 'Arrest charge information',
    key: 'arrestCharges',
    size: { md: 2 },
    items: [
      { label: 'Arrest Offense ID', value: 'number' },
      { label: 'Penal code', value: 'penalCode' },
      { label: 'Law description', value: 'penalCode.lawDescription' },
      { label: 'Attempt indicator', value: 'attemptIndicator' },
    ],
    isList: true,
  },
  {
    title: 'Arrest details',
    key: 'arrestDetails',
    size: { md: 2 },
    items: [
      { label: 'Arrest location', value: 'arrestLocation' },
      { label: 'Arrest date', value: 'arrestDate' },
      { label: 'Arrest type', value: 'arrestType' },
      { label: 'Arrest status', value: 'arrestStatus' },
      { label: 'Arresting officer', value: 'arrestingOfficer' },
      { label: 'Booking officer', value: 'bookingOfficer' },
      { label: 'Arrestee attitude', value: 'attitude' },
      { label: 'Arrestee medical attention', value: 'medicalAttention' },
      { label: 'Arrestee injury / illness', value: 'injury' },
      { label: 'Arrestee drugs narcotics', value: 'drugsNarcotics' },
      { label: 'Arrestee blood alcohol level', value: 'bloodAlcoholLevel' },
      { label: 'Juvenile release status', value: 'juvenileReleaseStatus' },
      { label: 'Arrestee weapons', value: 'arresteeWeapons' },
      { label: 'Arrest larceny type', value: 'arrestLarcenyType' },
      { label: 'Arrest notes', value: 'notes' },
    ],
  },
  {
    title: 'Arrest files',
    key: 'files',
    size: { md: 2 },
    items: [
      { label: 'File name', value: 'name' },
      { label: 'Description', value: 'description' },
    ],
    isList: true,
  },
];
